import { Component } from '@angular/core';
import { IdpService } from './auth/services/auth.service';
import { OAuthService } from 'angular-oauth2-oidc';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  status = false;
  loading = false;
  title = 'beneflex';
  constructor(
    private readonly oauthService: OAuthService,
    private _idpService: IdpService,
    private router: Router,
  ) {
    this._idpService.admin.subscribe((status) => {
      const evalue = JSON.parse(localStorage.getItem('admin') || '');
      this.status = status || evalue;
    });

    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationStart) {
        this.loading = true;
      }
      if (
        ev instanceof NavigationEnd ||
        ev instanceof NavigationCancel ||
        ev instanceof NavigationError
      ) {
        this.loading = false;
      }
    });
  }

  renderComponent() {
    const userProfile = this._idpService.getUserProfile();
    return userProfile === undefined ? false : true;
  }
}
